import {Box, Button, Container, Typography} from "@mui/material";
import useScrollToTop from "../../hooks/useScrollToTop";
import Footer from "../../components/Footer";
import useCallDataApi from "../../hooks/data";
import {useEffect, useState, useContext} from "react";
import Loading from "../../components/Loading";
import DrawerAppbar from "../../components/DrawerAppbar";
import {useTranslation} from "react-i18next";
import ConfigContext from "../../context/ConfigContext";
import adventure from '../../assets/adventure/adventure.jpeg'
import logo from '../../assets/shared/jet-adventure-logo-color.svg'
import ImageStack from "../../components/ImageStack";
import CountUpGrid from "../../components/CountUpGrid";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import {useHistory} from "react-router-dom";
import HeroImageAdventure from "../../components/HeroImageAdventure";


const Adventures = () => {
    const {t} = useTranslation()
    const {language} = useContext(ConfigContext)
    document.title = `Jet Travel | ${t('adventure.headline')}`
    useScrollToTop()
    const history = useHistory()

    const {getData: fetchAdventure} = useCallDataApi('adventure')
    const [adventures, setAdventures] = useState([])
    const [loading, setLoading] = useState(false)

    const numbers = [
        {number: 134, unit: t('adventure.firstNumber'), description: t('adventure.firstNumberDescription')},
        {number: 71, unit: t('adventure.secondNumber'), description: t('adventure.secondNumberDescription')},
        {number: 58, unit: t('adventure.thirdNumber'), description: t('adventure.thirdNumberDescription')},
        {number: 88430, unit: t('adventure.fourthNumber'), description: t('adventure.fourthNumberDescription')},
    ]

    useEffect(() => {
        setLoading(true)
        fetchAdventure().then(r => setAdventures(r)).finally(() => setLoading(false))
    }, [])


    return <DrawerAppbar fade>
        <HeroImageAdventure logo={logo} description={t('adventure.description')} title={t('adventure.headline')} underlineColor='#ff0000' image={adventure}/>
        <div style={{ marginBottom: '64px'}}>

            <Box sx={{margin: 3}}>
                <Button onClick={() => history.goBack()} variant='outlined' startIcon={<ArrowBackIosNewRoundedIcon/>}>{t('general.back')}</Button>
            </Box>


            <Typography variant='h2' gutterBottom textAlign='center'>{t('adventure.actualAdventure')}</Typography>
            <ImageStack images={adventures?.filter(s => s?.actual)?.map(adventure => ({image: adventure?.image, title: adventure?.translations[language]?.name, description: adventure?.translations[language]?.summary, link: `/adventures/${adventure?.id}`}))}/>


            <Typography marginTop={3} variant='h2' gutterBottom textAlign='center'>{t('adventure.previousAdventure')}</Typography>
            <ImageStack images={adventures?.filter(s => !s?.actual)?.map(adventure => ({image: adventure?.image, title: adventure?.translations[language]?.name, description: adventure?.translations[language]?.summary, link: `/adventures/${adventure?.id}`}))}/>
        </div>
        <Footer />

        <Loading isLoading={loading}/>
    </DrawerAppbar>
}

export default Adventures